// src/components/PrivateRoute.js
import React, { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { clearAuth } from "../redux/slices/authSlice";

const LogoutAndRedirect = ({ to }) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(clearAuth());
  }, [dispatch]);

  return <Navigate to={to} replace />;
};

// This component will check if the user is authenticated
const PrivateRoute = ({ element }) => {
  const token = useSelector((state) => state?.authReducer?.tokenData?.token);
  const userRole = useSelector(
    (state) => state?.authReducer?.tokenData?.user?.role,
  );
  const location = useLocation();

  if (!token) {
    // If the user is not authenticated, redirect them to the appropriate login page
    const pathname = location.pathname;

    if (
      (userRole && userRole.toLowerCase() === "fundraiser") ||
      pathname.startsWith("/fundraiser")
    ) {
      return <Navigate to="/fundraiser/account-login" />;
    }

    if (
      (userRole && userRole.toLowerCase() === "merchant") ||
      pathname.startsWith("/merchant")
    ) {
      return <Navigate to="/merchant/account-login" />;
    }

    // For all other users or when role is not set, redirect to main login
    return <Navigate to="/" />;
  }

  // If the user is authenticated, check for role mismatches on fundraiser paths
  const pathname = location.pathname;
  const normalizedRole =
    typeof userRole === "string" ? userRole.toLowerCase() : userRole;

  if (pathname.startsWith("/fundraiser") && normalizedRole !== "fundraiser") {
    return <LogoutAndRedirect to="/fundraiser/account-login" />;
  }

  // If the user is authenticated and authorized, return the element
  return element;
};

export default PrivateRoute;
